﻿export class CustomerModel {
    BusinessIdentity: string;
}
